import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ChangeOrgModalNew = ({ open, setOpen  }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
     const [orgs, setOrgs] = useState()
    const navigate = useNavigate()
    const {route_id} = useParams()
    const {call_id} = useParams()
      const [err_msg, setErrorMsg] = useState(null);
      const [loader, setLoader] = useState(false);
  const changeOrganization = async (org_id) => {
    try {
      const { fetchAndSetOrganization } = await import("../../utils/organizationService");
      await fetchAndSetOrganization(org_id);
      window.location.reload();
    } catch (error) {
      // Log for production diagnostics when change organization fails
      console.error("ChangeOrgModalNew: change organization failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  useEffect(() => {
    const loadOrgs = async () => {
      const { getAllOrgs } = await import('../../utils/getAllOrgs');
      try {
        await getAllOrgs(setOrgs, setLoader);
      } catch (error) {
        // Log for production diagnostics when org list fails to load
        console.error('[ChangeOrgModalNew] Error loading organizations:', error);
      }
    };
    loadOrgs();
  }, []);
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Alert !!</div>


        <div className="lg:text-[14px] text-[13px] text-center mb-2" >
        Oops! We couldn't find a record for {route_id ? 'route' : 'call'} <span className="font-bold"> {route_id || call_id}</span> in <span className="font-bold">{JSON.parse(localStorage.getItem('organization'))?.organization_name?.S}</span> , 
        Is it possible the URL is incorrect or that you mean to be logged in as a different organization? 
        If you need help, please <a className="text-blue-800 hover:underline" href='mailto:hello@twilanswer.com'>contact support</a>."

        
        </div>

        <div>
              <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={
                          user?.relatedOrgs.L.filter(
                            (e) =>
                              e?.M.org_id.S ===
                              JSON.parse(localStorage.getItem("organization")).orgId.S
                          )[0]?.M.org_id.S
                        }
                        onChange={(f) => {
                          changeOrganization(f.target.value);
                        }}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {user?.relatedOrgs.L.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.M.org_id.S}>{orgs?.find((e)=> e.orgId.S === item.M.org_id.S)?.organization_name.S}</MenuItem>
                          );
                        })}
                      </Select>
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
      {loader ? (
          <CircularProgress size={"1.0rem"} sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
      ): (
        <div className="flex items-center justify-center space-x-3 mt-4">
          <Button
          sx={{
            textTransform: "none",
            bgcolor: "rgba(236,72,92,0.1)",
            color: "rgba(236,72,92,1)",
            py: "6px",
            px: "30px",
            borderRadius: "7px",
            
            fontSize: { lg: "14px", xs: "13px" },
            width: "fit",
          }}
          onClick={()=> {
            console.info("[Auth] Logging out: user chose Logout from change-org modal (new).");
            localStorage.clear()
            navigate('/login')
          }}
        >
          Logout
        </Button>

        <Button
          variant="contained"
            color="primary"
            sx={{
            py: "6px",
            px: "30px",
            borderRadius: "7px",
            
            fontSize: { lg: "14px", xs: "13px" },
            width: "fit",
          }}
          onClick={()=> {
            
            {route_id ? (
                navigate('/dashboard/call-routings')
            ): (
                navigate('/dashboard/')
            )}
          }}
        >
          Go to {route_id ? 'routes' : 'dashboard'}
        </Button>

</div>        
      )}
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default ChangeOrgModalNew;
